import { CalculatorWidget } from "components/CalculatorWidget";

import { CALCULATOR_TYPES } from "constants/calculator";

import { WidgetOptionsProvider } from "context/widgetOptions";

const App = ({
  options,
}: {
  options?: {
    type?: typeof CALCULATOR_TYPES;
    [key: string]: any;
  };
}) => {
  return (
    <WidgetOptionsProvider options={options}>
      <CalculatorWidget
        initialType={options?.type as any}
        {...options}
      />
    </WidgetOptionsProvider>
  );
};

export default App;
